var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{staticClass:"list-item-multiline d-flex"},[_c('div',{staticClass:"d-flex my-auto flex-wrap pt-2 text-break pre-line"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }